import ID from './ID'

export interface TacticPlatformRequest {
  id?: string
  name: string
  plan: string
  creator?: string
  description?: string
}

export default class TacticPlatform {
  constructor(
    public id: ID = new ID(),
    public creatorId: ID = new ID(),
    public name: string = '',
    public planId: ID = new ID(), // Owning Lead or Individual plan. Empty on platforms embedded in a plan response.
    public description: string = '',
    public tacticCount: number | null = null // null when the API doesn't send a usage count
  ) {}

  public get key() {
    return 'tactic-platform-' + this.id.intID.toString()
  }

  // Platform names are unique per plan, ignoring case and surrounding whitespace
  public static isSameName(a: string, b: string): boolean {
    return a.trim().toLowerCase() === b.trim().toLowerCase()
  }

  public static fromResponseObject(obj): TacticPlatform {
    if (!obj) return new TacticPlatform()

    return new TacticPlatform(
      ID.fromResponseObject(obj.id, 'tactic_platforms'),
      obj.creator ? ID.fromResponseObject(obj.creator, 'users') : new ID(),
      obj.name ?? '',
      obj.plan ? ID.fromResponseObject(obj.plan, 'plans') : new ID(),
      obj.description ?? '',
      typeof obj.tacticCount === 'number' ? obj.tacticCount : null
    )
  }

  public forRequestObject(): TacticPlatformRequest {
    const request: TacticPlatformRequest = {
      name: this.name,
      plan: this.planId.apiID,
    }
    if (this.id.intID !== 0) {
      request.id = this.id.apiID
    }
    // Omit creator when unknown: PUT only updates the fields it's sent, and null would clear it
    if (this.creatorId.intID !== 0) {
      request.creator = this.creatorId.apiID
    }
    if (this.description) {
      request.description = this.description
    }
    return request
  }
}
